import './index.scss';
import ReactDOM from 'react-dom/client';
import Root from './root';
import { armChunkReload } from './utils/chunkReload';

// TELV1-550 — must be listening before the router's first lazy import.
armChunkReload();

ReactDOM.createRoot(document.getElementById('root')!).render(<Root />);
